var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 17,
  fill: "none",
  viewBox: "0 0 14 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#49475A",
  d: "M6 0v1.333H4.667v1.334H6V4h1.333V2.667h1.334V1.333H7.333V0zM0 1.333v15.334h6v-2h1.333v2h6V1.333H10v1.334h2v12.666H8.667v-2h-4v2H1.333V2.667h2V1.333zm3.333 4v1.334h1.334V5.333zm2.667 0v1.334h1.333V5.333zm2.667 0v1.334H10V5.333zM3.333 8v1.333h1.334V8zM6 8v1.333h1.333V8zm2.667 0v1.333H10V8zm-5.334 2.667V12h1.334v-1.333zm2.667 0V12h1.333v-1.333zm2.667 0V12H10v-1.333z"
})));
export { SvgReportIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/reportIcon.svg";